import { gql } from 'apollo-angular';

export const TriggerGetResponseEventDocument = gql`
  mutation triggerGetResponseEvent($eventType: GetResponseEvent!) {
    triggerGetResponseEvent(eventType: $eventType)
  }
`;
